import { FC } from 'react';

import { makeFullHeadMprTileAnnotations } from '@/shared/graphics/medicalImageRender/MedicalImageRender';
import { AnnotationsOverlay } from '@/shared/graphics/RenderComponents/AnnotationsOverlay';

import { MedicalImage, type MedicalImageProps } from '@/features/medicalImage';

import type {
  FullHeadMprSliceGroupView,
  FullHeadMprSliceRecordView,
  FullHeadMprSliceTileView,
} from '../../config';
import { makeTileMedicalImage } from '../../lib';

type FullHeadMprSliceImageProps = Omit<
  MedicalImageProps,
  'medicalImage' | 'imageOverlay' | 'selfPaintSrc'
> & {
  src: string;
  tile: FullHeadMprSliceTileView;
  group?: FullHeadMprSliceGroupView;
  record?: FullHeadMprSliceRecordView;
};

export const FullHeadMprSliceImage: FC<FullHeadMprSliceImageProps> = (
  props,
) => {
  const { group, src, tile, record, ...medicalImageProps } = props;

  const tileAnnotations = makeFullHeadMprTileAnnotations({
    displayView: tile.displayView ?? (tile.kind === 'view' ? tile.view : null),
    record,
  });

  return (
    <MedicalImage
      {...medicalImageProps}
      medicalImage={makeTileMedicalImage({ group, tile })}
      selfPaintSrc={src}
      imageOverlay={
        tileAnnotations && <AnnotationsOverlay {...tileAnnotations} />
      }
    />
  );
};
